import { gql } from "@apollo/client";

const GET_SALES =
  gql(`query Query($aggregate: Aggregate, $filter: FilterSalesInput) {
    sales(aggregate: $aggregate, filter: $filter)
  }
  `);

const GET_REVENUE =
  gql(`query Query($aggregate: Aggregate, $filter: FilterSalesInput) {
  revenue(aggregate: $aggregate, filter: $filter)
}
  `);

const GET_REGISTERS =
  gql(`query Query($aggregate: Aggregate, $filter: FilterUserInput) {
  registeredUsers(aggregate: $aggregate, filter: $filter)
}
  `);

const GET_REGISTERS_BY_PROGRESS =
  gql(`query Query {
  registersByProgress
}
  `);

const GET_USER_REPORT = gql(`
  query Query($id: ID!) {
  userReport(id: $id)
}
  `)

const GET_BOOKING_STATISTICS = gql(`
  query BookingStatistics($bookingModuleId: ID!, $startDate: String!, $endDate: String!) {
    bookingStatistics(bookingModuleId: $bookingModuleId, startDate: $startDate, endDate: $endDate) {
      reservationsByDay { date count }
      statusTotals { status count }
      revenueByDay { date amount }
      totalReservations
      totalRevenue
      totalConfirmedAllTime
      totalRevenueAllTime
    }
  }
`);

export { GET_SALES, GET_REVENUE, GET_REGISTERS, GET_REGISTERS_BY_PROGRESS, GET_USER_REPORT, GET_BOOKING_STATISTICS };
